import { SxProps } from '@mui/system';

export const popperStyles: SxProps = {
  zIndex: 1,
  '&.MuiPopper-root[data-popper-reference-hidden]': {
    visibility: 'hidden',
    pointerEvents: 'none',
  },
};
